import { render, staticRenderFns } from "./ModattaNavbar.vue?vue&type=template&id=0935015d"
import script from "./ModattaNavbar.vue?vue&type=script&lang=js"
export * from "./ModattaNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports